import { Component, Input, OnInit } from '@angular/core';
import {KeyValue} from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { HomeService } from 'src/app/services/home/home.service';
import { MotifTableModule, MotifDropdownModule, MotifIconModule, ModalSizes, MotifModal } from '@ey-xd/ng-motif';
import { DocumentList } from 'src/app/interfaces/engagement-details.interface';
import { DOC_TYPES, COMPETENCIES } from './../../constants/endpoint.constants';
import { Meeting, QuarterDetails } from 'src/app/interfaces/meeting.interface';
import { Subject } from 'rxjs';
import { MeetingDetailsModalComponent } from 'src/app/components/meeting-details-modal/meeting-details-modal.component';

@Component({
  selector: 'app-governance-meetings',
  templateUrl: './governance-meetings.component.html',
  styleUrls: ['./governance-meetings.component.scss']
})
export class GovernanceMeetingComponent implements OnInit {
  eventsSubject: Subject<void> = new Subject<void>();
  public docsData:DocumentList[] = [];
  public engagementId!:any;
  @Input() data: any = {
    'clientId': '',
    'isModal': false
  };
  public colDefs = [
    { field: "id", headerName: "ID",flex:.5 },
    { field: "competency", headerName: "Competency",flex:.6},
    { field: "type" , headerName: "Type",flex:.6},
    { field: "url" , headerName: "Document",flex:1,  cellRenderer: (params:any)=> this.renderDocLink(params)},
  ];
  public documents: DocumentList[] = [];
  pastMeetings: Meeting[] = [];  
  upcomingMeetings: any = [{ meetingDate: new Date().toISOString() }];
  public DOC_TYPES = DOC_TYPES
  public COMPETENCIES = COMPETENCIES;
  public pastMeetingsSort = 'asc' 
  sortedMeetings: Meeting[] = [];
  yearDefault: number = new Date().getFullYear(); //2024
  quarterDefault: string="Q"+(1+Math.floor(new Date().getMonth()/3)); 
  public selectedQuarter: QuarterDetails = {
    value: '',
    months: [],
    name: 'Select',
    index: 0,
    year: ''
  };
  quarters: QuarterDetails[] = [
    {value:'Q1',months:['Jan','Feb','Mar'], name: 'Jan - Mar', index: 1},
    {value:'Q2',months:['Apr','May','Jun'], name: 'Apr - Jun', index: 2},
    {value:'Q3',months:['Jul','Aug','Sep'], name: 'Jul - Sep', index: 3},
    {value:'Q4',months:['Oct','Nov','Dec'], name: 'Oct - Dec', index: 4}
  ];
  quarterDropDown: QuarterDetails[] = [{
    value: '',
    months: [],
    name: 'Select',
    index: 0,
    year: ''
  }];

  constructor(public modal: MotifModal,private router:Router,private route: ActivatedRoute, private homeServiceRef: HomeService, private motifTableModule: MotifTableModule) { }

  openDetailsModal(meeting:Meeting){
    const modalRef = this.modal.open(MeetingDetailsModalComponent, {
      size: ModalSizes.XL,
      data: meeting
    });
    modalRef.componentInstance.data = meeting;
    modalRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
    });
  }

  sortByDate(){
    if(this.pastMeetingsSort === 'asc'){
      this.pastMeetingsSort = 'desc';
      return this.sortedMeetings.length?this.sortedMeetings.sort((a:Meeting, b:Meeting) => new Date(b.meetingDate).getTime() - new Date(a.meetingDate).getTime()):[];
    }else{
      this.pastMeetingsSort = 'asc';
      return this.sortedMeetings.length?this.sortedMeetings.sort((b:Meeting, a:Meeting) => new Date(b.meetingDate).getTime() - new Date(a.meetingDate).getTime()):[];
    }
  }
  ngOnInit(): void {
    const id = this.route.snapshot.paramMap.get('id');
    const meetingId = this.route.snapshot.paramMap.get('meetingId');
    this.engagementId = id || this.data.clientId;
    console.log(this.engagementId);
    this.homeServiceRef.getGovernanceMeetings(this.engagementId).subscribe((res) => {
      if (!!res) {
        this.pastMeetings = JSON.parse(JSON.stringify(res));
        this.sortedMeetings = JSON.parse(JSON.stringify(res));
        this.sortedMeetings = JSON.parse(JSON.stringify(this.sortByDate()));
        if(meetingId){
          const meetingToOpen = this.pastMeetings.filter(meeting => meeting.uId === meetingId);
          if(meetingToOpen.length)
          this.openDetailsModal(meetingToOpen[0]);
          // open Modal
        }
      }
    });   
    this.getQuarterDetails();
  }

  getQuarterDetails(){
    const currentIdx= 1+Math.floor(new Date().getMonth()/3);
    for (let i = currentIdx-3; i < currentIdx+4; i++) {
      console.log(i);
      let quarter:any;
      if(Math.sign(i) === -1 || i === 0){
        quarter = this.quarters.find(obj=> obj.index === 4+i)
        this.quarterDropDown.push({...quarter, year: this.yearDefault-1})
      }else{
        if(i < 5){
          quarter = this.quarters.find(obj=> obj.index === i)
          this.quarterDropDown.push({...quarter, year: this.yearDefault})
        }else{
          quarter = this.quarters.find(obj=> obj.index === i-4)
          this.quarterDropDown.push({...quarter, year: this.yearDefault+1})
        }
      }
      // uncomment if to show the current quarter by default
      // if (i === currentIdx){
      //   this.selectedQuarter = {...quarter, year: this.yearDefault};
      //   this.updateQuarter(this.selectedQuarter);
      // }
    }

    //find the 3 quarters before current

    //find 3 quarters after current
  }

  updateQuarter(quarter:QuarterDetails){
    this.selectedQuarter = quarter;
    if(quarter.name !== 'Select'){
    this.sortedMeetings = JSON.parse(JSON.stringify(this.pastMeetings.filter((meeting:Meeting)=> 1+Math.floor(new Date(meeting.meetingDate).getMonth()/3) === quarter.index && new Date(meeting.meetingDate).getFullYear() === quarter.year)));
    }else{
      this.sortedMeetings = JSON.parse(JSON.stringify(this.pastMeetings));
    }
  }
  renderDocLink(param:any){
    return param.value.length?`<a target="_blank" href="${param.value}">${param.value.split("/").pop()}</a>`:'';
  }

  goHome()
  {
    this.router.navigate([`/home`, this.engagementId]);
  }

}
